import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { escapeRegExp } from 'lodash';

/**
 * A custom React hook that triggers a callback when a specific hash is present in the URL.
 *
 * @param {string} triggerHash - The hash string to trigger the callback. Alfanumeric only (no dashes or underscores, for instance)
 * @param {function} callback - The callback function to be executed when the trigger hash is present.
 * @return {void} This hook does not return a value.
 */
export function useHashTriggeredEffect(triggerHash, callback) {
    const { hash, pathname } = useLocation(),
        history = useHistory();

    if (!triggerHash || triggerHash.match(/\W/)) {
        throw new Error('Invalid trigger hash');
    }

    useEffect(() => {
        const exp = new RegExp(`\\b` + escapeRegExp(triggerHash) + `\\b`);

        if (exp.test(hash)) {
            // remove trigger string from hash
            const newHash = hash
                .replace(exp, '')
                .replace(',,', ',')
                .replace(/^#,/, '#')
                .replace(/#$/, '');
            history.replace(pathname + newHash);

            // executes callback
            callback();
        }
    }, [pathname, hash, triggerHash, callback]);
}
